<template>
	<div class="indexs" v-swipeup.passive='touchUp' v-swipedown.passive="touchdown" id="resShow">
    <div class="indHea">
      <img src="../assets/img/logo.png" alt="logo">
      <ul>
        <li v-for="(item,index,name) in tabs" :key="name" @click="tab=index" :class="{active:tab==index}">{{item}}</li>
      </ul>
      <div>
        <p @click="lists">菜单<span></span></p>
        <ul v-if="lis==1">
          <li v-for="(item,index,name) in tabs" :key="name" @click="tab=index,lis=0" :class="{active:tab==index}">{{item}}</li>
        </ul>
      </div>
    </div>
    <transition name="fade">
      <div class="indCenS" v-if="tab==0">
        <img src="../assets/img/index.png" alt="logo">
        <p><span @click="goBeian">陕ICP备15007224号  出版物网络交易平台服务经营备案号：新出发批兼零字第023号</span></p>
      </div>
      <indexCenterF v-if="tab==1"></indexCenterF>
      <indexCenterH v-if="tab==2"></indexCenterH>
      <indexCenterJ v-if="tab==3"></indexCenterJ>
      <indexCenterG v-if="tab==4"></indexCenterG>
      <indexCenterZ v-if="tab==5"></indexCenterZ>
    </transition>
	</div>
</template>

<script>
  import indexCenterF from "../components/indexCenterF";
  import indexCenterH from "../components/indexCenterH";
  import indexCenterJ from "../components/indexCenterJ";
  import indexCenterG from "../components/indexCenterG";
  import indexCenterZ from "../components/indexCenterZ";

	export default {
		name: 'indexs',
    components:{
    	indexCenterF,indexCenterH,indexCenterJ,indexCenterG,indexCenterZ
    },
		data () {
			return {
				tab:0,
				lis:0,
        flag:false,
				tabs:['首页','服务项目','合作伙伴','解决方案','关于我们','招聘']
			}
		},
    mounted:function(){
      var tach = this;
      if (window.addEventListener)
      window.addEventListener('DOMMouseScroll', wheel, false);
      window.onmousewheel = document.onmousewheel = wheel;
      function wheel(event){
        var delta = 0;
        if (!event) event = window.event;
        if (event.wheelDelta) {
            delta = event.wheelDelta/120;
            if (window.opera) delta = -delta;
        } else if (event.detail) {
            delta = -event.detail/3;
        }
        if (delta)
          handle(delta);
      }
      function handle(delta) {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if(tach.flag==false){
          if (delta<0){//向下
            if(tach.tab<=4){
              if(scrollTop + clientHeight > scrollHeight -1){
                tach.tab = tach.tab+1
                window.scrollTo(0,0);
                tach.flag = true;
              }
            }
          }else{//向上
            if(tach.tab>0){
              if(scrollTop < 1){
                tach.tab = tach.tab-1
                window.scrollTo(0,0);
                tach.flag = true;
              }
            }
          }
          setTimeout(function(){
            tach.flag = false;
          },1000);
        }
      }
    },
		methods:{
      lists(){
        if(this.lis == 0){
          this.lis = 1;
        }else{
          this.lis = 0;
        }
      },
      goBeian(){
        window.location.href = 'http://www.beian.miit.gov.cn';
      },
      touchUp(){
        if(this.tab<=4){
          this.tab = this.tab+1
          window.scrollTo(0,0);
        }
      },
      touchdown(){
        if(this.tab>0){
          this.tab = this.tab-1
          window.scrollTo(0,0);
        }
      }
		}
	}
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }
  .indexs{
    .indHea{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 2rem;
      height: 8vh;
      img{
        width: 12rem;
      }
      ul{
        display: flex;
        li{
          font-size: 1rem;
          color: #a0a0a0;
          padding: 0 1rem;
          line-height: 2.2rem;
          margin: 0 1rem;
          cursor: pointer;
        }
        .active{
          color: red;
          border-bottom: 1px solid red;
        }
      }
      div{
        display: none;
        position: relative;
        p{
          font-size: 1rem;
          color: #a0a0a0;
          padding: 0 1rem;
          line-height: 2.2rem;
          margin: 0 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          span{
            border: .5rem solid transparent;
            border-top: .5rem solid #a0a0a0;
            margin-top: .5rem;
            margin-left: 1rem;
          }
        }
        ul{
          display: none;
          position: absolute;
          background: #fff;
          top: 2.4rem;
          right: 0;
          width: 9rem;
          z-index: 10;
          li{
            text-align: center;
            margin: 0;
            padding: 0;
            border-bottom: 1px solid #e9e9e9;
            font-size: 1rem;
          }
          li:hover{
            background: #e7effa;
          }
          li:nth-last-child(1){
            border-bottom: none;
          }
          .active{
            color: red;
            font-size: 1.2rem;
            line-height: 2.6rem;
            border-bottom: 1px solid #e9e9e9;
          }
        }
      }
    }
    .indCenS{
      background: url(../assets/img/index-bg.png) no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 92vh;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 30%;
      }
      p{
        position: absolute;
        left: 0;
        bottom: 2rem;
        width: 100%;
        color: #3a3a3a;
        text-align: center;
        span:hover{
          color: #000;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    @media screen and (max-width: 980px) {
      .indHea{
        padding: 0 0 0 1rem;
        img{
          width: 20%;
        }
        ul{
          display: none;
        }
        div{
          display: block;
          ul{
            display: block;
          }
        }
      }
      .indCenS{
        img{
          width: 50%;
        }
      }
    }
    @media screen and (max-width: 600px) {
      .indHea{
        img{
          width: 30%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexHeader.vue